var getChatLink = function getChatLink(_ref) {
  var link = _ref.link,
      user = _ref.user,
      openAfterHours = _ref.openAfterHours;
  var strChatLink = link;

  if (window.MEDIAHUIS) {
    if (window.MEDIAHUIS.user) {
      var strEmail = window.MEDIAHUIS.user.email;
      var strName = window.MEDIAHUIS.user.firstName;
      strChatLink += "?email=" + encodeURI(strEmail || '') + "&name=" + (strName || '') + "&offline=" + (openAfterHours ? '1' : '');
    }
  } else if (user) {
    strChatLink += "?email=" + (user.emailAddress || '') + "&name=" + (user.name || '') + "&offline=" + (openAfterHours ? '1' : '');
  } else {
    strChatLink += "?offline=" + (openAfterHours ? '1' : '');
  }

  return strChatLink;
};

export default getChatLink;